import urls from "./urls";
import {BACKOFFICE_URL, BASE_URL, GATEWAY_URL, SHIFT4_BACKOFFICE_URL, SHIFT4_BASE_URL, SHIFT4_GATEWAY_URL} from "./env";

export const BACKOFFICE_ORIGIN = urls.getOrigin(BACKOFFICE_URL);
export const GATEWAY_ORIGIN = urls.getOrigin(GATEWAY_URL);
export const JS_ORIGIN = urls.getOrigin(BASE_URL);

export const LEGACY_ORIGINS = Object.freeze([
    JS_ORIGIN, BACKOFFICE_ORIGIN, GATEWAY_ORIGIN
])

export const SHIFT4_BACKOFFICE_ORIGIN = urls.getOrigin(SHIFT4_BACKOFFICE_URL);
export const SHIFT4_GATEWAY_ORIGIN = urls.getOrigin(SHIFT4_GATEWAY_URL);
export const SHIFT4_JS_ORIGIN = urls.getOrigin(SHIFT4_BASE_URL);

export const SHIFT4_ORIGINS = Object.freeze([
    SHIFT4_JS_ORIGIN, SHIFT4_BACKOFFICE_ORIGIN, SHIFT4_GATEWAY_ORIGIN
])

const ORIGIN_WHITELIST = Object.freeze([...LEGACY_ORIGINS, ...SHIFT4_ORIGINS]);

export const isOriginAllowed = (url) => {
    const origin = urls.getOrigin(url);
    return ORIGIN_WHITELIST.indexOf(origin) > -1;
}

export const isLegacyOrigin = (origin) => LEGACY_ORIGINS.indexOf(origin) > -1
export const isShift4Origin = (origin) => SHIFT4_ORIGINS.indexOf(origin) > -1
